(function () {
  const STYLE_ID = 'ag-product-lightbox-style';

  function injectProductLightboxStyles() {
    let style = document.getElementById(STYLE_ID);

    if (!style) {
      style = document.createElement('style');
      style.id = STYLE_ID;
      document.head.appendChild(style);
    }

    style.textContent = `
      .pswp--ag-direct-image-view {
        --pswp-bg: #ffffff !important;
        --pswp-placeholder-bg: #ffffff !important;
        z-index: 999999999 !important;
      }

      .pswp--ag-direct-image-view,
      .pswp--ag-direct-image-view .pswp__bg,
      .pswp--ag-direct-image-view .pswp__scroll-wrap,
      .pswp--ag-direct-image-view .pswp__container,
      .pswp--ag-direct-image-view .pswp__item {
        background: #ffffff !important;
      }

      .pswp--ag-direct-image-view .pswp__bg {
        opacity: 1 !important;
        background: #ffffff !important;
      }

      .pswp--ag-direct-image-view .pswp__img {
        background: transparent !important;
        border-radius: 0 !important;
        box-shadow: none !important;
        object-fit: contain !important;
        cursor: default !important;
      }

      .pswp--ag-direct-image-view .pswp__top-bar {
        position: fixed !important;
        top: 0 !important;
        left: 0 !important;
        right: 0 !important;
        height: 64px !important;
        background: transparent !important;
        pointer-events: none !important;
        display: block !important;
      }

      .pswp--ag-direct-image-view .pswp__preloader,
      .pswp--ag-direct-image-view .pswp__button--zoom {
        display: none !important;
        opacity: 0 !important;
        visibility: hidden !important;
      }

      .pswp--ag-direct-image-view .pswp__counter {
        position: fixed !important;
        top: 22px !important;
        left: 40px !important;
        color: #111111 !important;
        opacity: 1 !important;
        font-size: 14px !important;
        font-weight: 500 !important;
        line-height: 1 !important;
        text-shadow: none !important;
        pointer-events: auto !important;
      }

      .pswp--ag-direct-image-view .pswp__button {
        color: #111111 !important;
        background: transparent !important;
        opacity: 1 !important;
        box-shadow: none !important;
        border: 0 !important;
        outline: 0 !important;
      }

      .pswp--ag-direct-image-view .pswp__button svg,
      .pswp--ag-direct-image-view .pswp__button path {
        stroke: #111111 !important;
        color: #111111 !important;
      }

      .pswp--ag-direct-image-view .pswp__button--close {
        position: fixed !important;
        top: 14px !important;
        right: 22px !important;
        left: auto !important;
        bottom: auto !important;
        margin: 0 !important;
        transform: none !important;
        width: 44px !important;
        height: 44px !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        pointer-events: auto !important;
        z-index: 999999999 !important;
      }

      .pswp--ag-direct-image-view .pswp__button--close svg {
        width: 18px !important;
        height: 18px !important;
      }

      .pswp--ag-direct-image-view .pswp__button--arrow {
        position: fixed !important;
        top: 50% !important;
        bottom: auto !important;
        margin: 0 !important;
        transform: translateY(-50%) !important;
        width: 58px !important;
        height: 80px !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        background: transparent !important;
        color: #111111 !important;
        opacity: 1 !important;
        pointer-events: auto !important;
        z-index: 999999998 !important;
        transition: opacity 0.2s ease !important;
      }

      .pswp--ag-direct-image-view .pswp__button--arrow--prev {
        left: 10px !important;
        right: auto !important;
      }

      .pswp--ag-direct-image-view .pswp__button--arrow--next {
        right: 10px !important;
        left: auto !important;
      }

      .pswp--ag-direct-image-view .pswp__button--arrow svg {
        position: static !important;
        width: 20px !important;
        height: 22px !important;
        margin: 0 !important;
      }

      .pswp--ag-direct-image-view .pswp__button--arrow--next svg {
        transform: rotate(180deg) !important;
      }

      .pswp--ag-direct-image-view .pswp__button--arrow.ag-pswp-arrow-disabled,
      .pswp--ag-direct-image-view .pswp__button--arrow:disabled,
      .pswp--ag-direct-image-view .pswp__button--arrow[disabled],
      .pswp--ag-direct-image-view .pswp__button--arrow[aria-disabled="true"] {
        opacity: 0.22 !important;
        pointer-events: none !important;
        cursor: default !important;
      }

      .pswp--ag-direct-image-view .pswp__button--arrow::before,
      .pswp--ag-direct-image-view .pswp__button--arrow::after,
      .pswp--ag-direct-image-view .pswp__button--close::before,
      .pswp--ag-direct-image-view .pswp__button--close::after {
        display: none !important;
        content: none !important;
      }

      .splide__gallery .product__media,
      .splide__gallery .product__modal-opener,
      .splide__gallery .product__media-toggle,
      .splide__gallery .product-media-container,
      .splide__gallery .media,
      .splide__gallery img {
        cursor: zoom-in !important;
      }

      @media screen and (max-width: 749px) {
        .pswp--ag-direct-image-view .pswp__counter {
          top: 18px !important;
          left: 35px !important;
          font-size: 13px !important;
        }

        .pswp--ag-direct-image-view .pswp__button--close {
          top: 8px !important;
          right: 10px !important;
          width: 44px !important;
          height: 44px !important;
        }

        .pswp--ag-direct-image-view .pswp__button--arrow {
          width: 46px !important;
          height: 64px !important;
        }

        .pswp--ag-direct-image-view .pswp__button--arrow--prev {
          left: 0 !important;
        }

        .pswp--ag-direct-image-view .pswp__button--arrow--next {
          right: 0 !important;
        }
      }
    `;
  }

  function getLargestSrcFromSrcset(srcset) {
    if (!srcset) return null;

    const sources = srcset
      .split(',')
      .map(function (item) {
        const parts = item.trim().split(/\s+/);
        const url = parts[0];
        const width = parts[1] ? parseInt(parts[1].replace('w', ''), 10) : 0;

        return {
          url: url,
          width: isNaN(width) ? 0 : width
        };
      })
      .filter(function (item) {
        return item.url;
      })
      .sort(function (a, b) {
        return b.width - a.width;
      });

    return sources.length ? sources[0] : null;
  }

  function cleanShopifyImageUrl(url) {
    if (!url) return '';

    try {
      const cleanUrl = new URL(url, window.location.origin);

      cleanUrl.searchParams.delete('width');
      cleanUrl.searchParams.delete('height');
      cleanUrl.searchParams.delete('crop');

      return cleanUrl.href;
    } catch (e) {
      return url;
    }
  }

  function getLightboxItems(galleryEl) {
    const iconItems = galleryEl.querySelectorAll('.product__media-icon-image');

    if (iconItems.length) {
      return Array.from(iconItems);
    }

    return Array.from(galleryEl.querySelectorAll('.product__media img, .media img'));
  }

  function getChildrenSelector(galleryEl) {
    if (galleryEl.querySelector('.product__media-icon-image')) {
      return '.product__media-icon-image';
    }

    return '.product__media img, .media img';
  }

  function getMediaWrapper(item) {
    return (
      item.closest('.product__media') ||
      item.closest('.product__media-item') ||
      item.closest('.splide__slide') ||
      item.closest('li') ||
      item.parentElement
    );
  }

  function getMediaImage(item) {
    const mediaWrapper = getMediaWrapper(item);

    if (item.tagName && item.tagName.toLowerCase() === 'img') {
      return item;
    }

    if (!mediaWrapper) {
      return item.querySelector ? item.querySelector('img') : null;
    }

    const preferredImage =
      mediaWrapper.querySelector('.product-media-container img[srcset]') ||
      mediaWrapper.querySelector('.media img[srcset]') ||
      mediaWrapper.querySelector('img[srcset]') ||
      mediaWrapper.querySelector('.product-media-container img[src]') ||
      mediaWrapper.querySelector('.media img[src]') ||
      mediaWrapper.querySelector('img[src]');

    return preferredImage || null;
  }

  function prepareLightboxItems(galleryEl) {
    const items = getLightboxItems(galleryEl);

    items.forEach(function (item) {
      const image = getMediaImage(item);
      if (!image) return;

      const largestSrcData = getLargestSrcFromSrcset(image.getAttribute('srcset'));

      const imageSrc =
        (largestSrcData && largestSrcData.url) ||
        image.currentSrc ||
        image.src ||
        item.getAttribute('href') ||
        item.getAttribute('data-pswp-src');

      const finalSrc = cleanShopifyImageUrl(imageSrc);
      if (!finalSrc) return;

      const imageNaturalWidth =
        image.naturalWidth ||
        parseInt(image.getAttribute('width'), 10) ||
        parseInt(item.getAttribute('data-pswp-width'), 10) ||
        2000;

      const imageNaturalHeight =
        image.naturalHeight ||
        parseInt(image.getAttribute('height'), 10) ||
        parseInt(item.getAttribute('data-pswp-height'), 10) ||
        2000;

      const finalWidth =
        (largestSrcData && largestSrcData.width) ||
        imageNaturalWidth ||
        2000;

      const finalHeight =
        imageNaturalWidth && imageNaturalHeight
          ? Math.round((finalWidth * imageNaturalHeight) / imageNaturalWidth)
          : imageNaturalHeight;

      item.setAttribute('data-pswp-src', finalSrc);
      item.setAttribute('data-pswp-width', finalWidth);
      item.setAttribute('data-pswp-height', finalHeight);

      if (item.tagName && item.tagName.toLowerCase() === 'a') {
        item.setAttribute('href', finalSrc);
      }
    });
  }

  function setArrowDisabled(button, disabled) {
    if (!button) return;

    if (disabled) {
      button.setAttribute('disabled', 'disabled');
      button.setAttribute('aria-disabled', 'true');
      button.setAttribute('tabindex', '-1');
      button.classList.add('ag-pswp-arrow-disabled');
    } else {
      button.removeAttribute('disabled');
      button.setAttribute('aria-disabled', 'false');
      button.setAttribute('tabindex', '0');
      button.classList.remove('ag-pswp-arrow-disabled');
    }
  }

  function updateLightboxNavigationState() {
    const lightbox = window.productPhotoSwipeLightbox;
    const pswp = lightbox && lightbox.pswp;

    if (!pswp || !pswp.element) return;

    const prevArrow = pswp.element.querySelector('.pswp__button--arrow--prev');
    const nextArrow = pswp.element.querySelector('.pswp__button--arrow--next');

    const currentIndex = typeof pswp.currIndex === 'number' ? pswp.currIndex : 0;

    let totalItems = 0;

    if (typeof pswp.getNumItems === 'function') {
      totalItems = pswp.getNumItems();
    } else if (pswp.options && pswp.options.dataSource && pswp.options.dataSource.length) {
      totalItems = pswp.options.dataSource.length;
    }

    setArrowDisabled(prevArrow, currentIndex <= 0);
    setArrowDisabled(nextArrow, totalItems > 0 && currentIndex >= totalItems - 1);
  }

  function getClickedLightboxIndex(target, galleryEl) {
    const items = getLightboxItems(galleryEl);
    if (!items.length) return -1;

    const clickedItem = target.closest('.product__media-icon-image, .product__media img, .media img');

    if (clickedItem) {
      const directIndex = items.indexOf(clickedItem);
      if (directIndex > -1) return directIndex;
    }

    const clickedWrapper =
      target.closest('.product__media') ||
      target.closest('.product__media-item') ||
      target.closest('.splide__slide') ||
      target.closest('li');

    if (!clickedWrapper) return -1;

    for (let i = 0; i < items.length; i++) {
      const itemWrapper = getMediaWrapper(items[i]);

      if (itemWrapper === clickedWrapper || clickedWrapper.contains(items[i]) || itemWrapper.contains(clickedWrapper)) {
        return i;
      }
    }

    return -1;
  }

  function unbindImageOpenClick() {
    if (window.agProductLightboxGallery && window.agProductLightboxClickHandler) {
      window.agProductLightboxGallery.removeEventListener('click', window.agProductLightboxClickHandler, true);
    }

    window.agProductLightboxGallery = null;
    window.agProductLightboxClickHandler = null;
  }

  function bindImageOpenClick(galleryEl) {
    unbindImageOpenClick();

    const clickHandler = function (event) {
      const target = event.target;

      if (!target || !target.closest) return;

      if (
        target.closest('.splide__arrow') ||
        target.closest('.thumbnail-carousel') ||
        target.closest('.thumbnail-list') ||
        target.closest('.thumbnail') ||
        target.closest('.pswp__button')
      ) {
        return;
      }

      const clickedMedia = target.closest(
        '.product__media-icon-image, .product__media-toggle, .product__modal-opener, .product-media-container, .product__media, .media, picture, img'
      );

      if (!clickedMedia || !galleryEl.contains(clickedMedia)) return;

      const index = getClickedLightboxIndex(target, galleryEl);
      if (index < 0) return;

      event.preventDefault();
      event.stopPropagation();

      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }

      prepareLightboxItems(galleryEl);

      if (window.productPhotoSwipeLightbox && typeof window.productPhotoSwipeLightbox.loadAndOpen === 'function') {
        window.productPhotoSwipeLightbox.loadAndOpen(index);
      }
    };

    window.agProductLightboxGallery = galleryEl;
    window.agProductLightboxClickHandler = clickHandler;

    galleryEl.addEventListener('click', clickHandler, true);
  }

  function destroyExistingLightbox() {
    if (!window.productPhotoSwipeLightbox) return;

    try {
      window.productPhotoSwipeLightbox.destroy();
    } catch (e) {}

    window.productPhotoSwipeLightbox = null;
  }

  function initProductLightbox() {
    injectProductLightboxStyles();
    destroyExistingLightbox();

    if (typeof PhotoSwipeLightbox === 'undefined' || typeof PhotoSwipe === 'undefined') return;

    const galleryEl = document.querySelector('.splide__gallery');
    if (!galleryEl) return;

    prepareLightboxItems(galleryEl);
    bindImageOpenClick(galleryEl);

    const childrenSelector = getChildrenSelector(galleryEl);

    const leftArrowSVGString =
      '<svg aria-hidden="true" focusable="false" fill="none" width="20" height="22" viewBox="0 0 16 18"><path d="M11 1 3 9l8 8" stroke="currentColor" stroke-linecap="square" stroke-width="2"></path></svg>';

    const closeSvgString =
      '<svg aria-hidden="true" focusable="false" fill="none" width="18" height="18" viewBox="0 0 16 16"><path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="1.5"></path></svg>';

    window.productPhotoSwipeLightbox = new PhotoSwipeLightbox({
      gallery: '.splide__gallery',
      children: childrenSelector,
      pswpModule: PhotoSwipe,

      mainClass: 'pswp--ag-direct-image-view',

      bgOpacity: 1,
      showHideAnimationType: 'fade',
      loop: false,
      counter: true,

      zoom: false,
      wheelToZoom: false,
      pinchToClose: true,
      doubleTapAction: false,

      imageClickAction: false,
      tapAction: false,
      bgClickAction: 'close',

      initialZoomLevel: function (zoomLevelObject) {
        return zoomLevelObject.fit;
      },

      secondaryZoomLevel: function (zoomLevelObject) {
        return zoomLevelObject.fit;
      },

      maxZoomLevel: function (zoomLevelObject) {
        return zoomLevelObject.fit;
      },

      padding: {
        top: 0,
        bottom: 0,
        left: 0,
        right: 0
      },

      arrowPrevSVG: leftArrowSVGString,
      arrowNextSVG: leftArrowSVGString,
      closeSVG: closeSvgString
    });

    window.productPhotoSwipeLightbox.addFilter('itemData', function (itemData) {
      if (itemData && itemData.src) {
        itemData.src = cleanShopifyImageUrl(itemData.src);
      }

      return itemData;
    });

    window.productPhotoSwipeLightbox.on('afterInit', function () {
      setTimeout(updateLightboxNavigationState, 0);
    });

    window.productPhotoSwipeLightbox.on('change', function () {
      setTimeout(updateLightboxNavigationState, 0);
    });

    window.productPhotoSwipeLightbox.on('openingAnimationEnd', function () {
      updateLightboxNavigationState();
    });

    window.productPhotoSwipeLightbox.on('contentActivate', function () {
      updateLightboxNavigationState();
    });

    window.productPhotoSwipeLightbox.init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductLightbox);
  } else {
    initProductLightbox();
  }

  document.addEventListener('shopify:section:load', initProductLightbox);

  let resizeTimer;

  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);

    resizeTimer = setTimeout(function () {
      initProductLightbox();
    }, 200);
  });
})();